module.exports = require('./helpers/bundle-url').getBundleURL('2c9kW') + "../images/train.fdf27324.svg";